import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import gql from "graphql-tag";

import { useQuery } from "react-apollo";
import { DateInput } from "../../../../../components/inputs";
import DaysUsed from "../../../../HRManagement/Employees/components/DaysUsed";

const SINGLE_EMPLOYEE_QUERY = gql`
  query Employee($where: EmployeeWhereUniqueInput!) {
    Employee(where: $where) {
      RecId
      VacationDaysAllowedThisYear
      VacationDayStartDate
      VacationDaysRenewalDate
      VacationDaysBalance
      PersonalDaysAllowedThisYear
      PersonalDayStartDate
      PersonalDaysRenewalDate
      PersonalDaysBalance
    }
  }
`;

const PTOOverview = ({ employeeRecId }) => {
  const { data: EmployeeData } = useQuery(SINGLE_EMPLOYEE_QUERY, {
    variables: { where: { RecId: parseInt(employeeRecId, 10) } }
  });

  const employee = EmployeeData?.Employee || {};

  return (
    <div>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Vacation Days Allowed This Year</Label>
              <Input readOnly value={employee.VacationDaysAllowedThisYear} />
            </Control>
          </Field>
          <Field>
            <Control>
              <DaysUsed
                showBalance
                daysAllowed={employee.VacationDaysAllowedThisYear}
                employeeRecId={employeeRecId}
                endDate={employee.VacationDaysRenewalDate}
                startDate={employee.VacationDayStartDate}
                type="vacation"
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Allotment Start Date</Label>
              <DateInput readOnly value={employee.VacationDayStartDate} />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Allotment Renewal Date</Label>
              <DateInput readOnly value={employee.VacationDaysRenewalDate} />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Personal Days Allowed This Year</Label>
              <Input readOnly value={employee.PersonalDaysAllowedThisYear} />
            </Control>
          </Field>
          <Field>
            <Control>
              <DaysUsed
                showBalance
                daysAllowed={employee.PersonalDaysAllowedThisYear}
                employeeRecId={employeeRecId}
                endDate={employee.PersonalDaysRenewalDate}
                startDate={employee.PersonalDayStartDate}
                type="sick"
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Allotment Start Date</Label>
              <DateInput readOnly value={employee.PersonalDayStartDate} />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Allotment Renewal Date</Label>
              <DateInput readOnly value={employee.PersonalDaysRenewalDate} />
            </Control>
          </Field>
        </Column>
      </Column.Group>
    </div>
  );
};

PTOOverview.propTypes = {
  employeeRecId: PropTypes.number
};

PTOOverview.defaultProps = {
  employeeRecId: 200
};
export default PTOOverview;
